import { logger } from '@heidi/runtime/logger';

import { applyUiAction, type VoiceUiActionPayload } from './applyUiAction';
import type { VoiceUiActionsPort } from './voice-ui-actions.port';

let loadPort: (() => VoiceUiActionsPort) | null = null;

/** Loader form: the port is read when an action arrives, not when this binds. */
export const configureVoiceUiActions = (load: () => VoiceUiActionsPort): void => {
  loadPort = load;
};

export const getVoiceUiActions = (): VoiceUiActionsPort | null =>
  loadPort ? loadPort() : null;

/** Test-only reset so a suite cannot leak a port into the next one. */
export const resetVoiceUiActionsForTests = (): void => {
  loadPort = null;
};

/**
 * Apply a voice UI action through the configured port. With no port the
 * outcome matches an unknown action: a warning and `false`.
 */
export const applyConfiguredVoiceUiAction = (payload: VoiceUiActionPayload): boolean => {
  const port = getVoiceUiActions();
  if (!port) {
    logger.warn('voice: ui actions not configured', { action: payload.action });
    return false;
  }
  return applyUiAction(payload, port);
};
